import { AccrualDate, AccrualDateCreate } from './@types/AccrualDate';
export class AccrualDateRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/accrual_dates';
    }
    async getAll(filters?: Record<string, any>): Promise<AccrualDate[]> {
        const response = await this.httpService.get<TKResponse<AccrualDate[]>>(this.baseUrl, filters);
        return response.data
            .map((accrual_date) => ({ ...accrual_date, id: accrual_date.accrual_date_id }))
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }
    async getOne(id: number): Promise<AccrualDate> {
        const response = await this.httpService.get<TKResponse<AccrualDate>>(`${this.baseUrl}/${id}`);
        return { ...response.data, id: response.data.accrual_date_id };
    }
    async create(data: AccrualDateCreate): Promise<AccrualDate | AccrualDate[]> {
        const response = await this.httpService.post<TKResponse<AccrualDate | AccrualDate[]>, AccrualDateCreate>(this.baseUrl, { data });
        return Array.isArray(response.data) ? response.data.map((accrual_date) => ({ ...accrual_date, id: accrual_date.accrual_date_id })) : { ...response.data, id: response.data.accrual_date_id };
    }
    async update(id: number, data: AccrualDateCreate): Promise<{ status: number | string; data: AccrualDate }> {
        const response = await this.httpService.patch<TKResponse<AccrualDate>, Partial<AccrualDateCreate>>(`${this.baseUrl}/${id}`, { data });
        return { status: response.status, data: { ...response.data, id: response.data.accrual_date_id, accrual_date_id: response.data.accrual_date_id } };
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}
